export default "__VITE_ASSET__CTBH7qtx__"